import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import React, { useCallback, useEffect, useState } from 'react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import * as P from 'common/data/Permissions/UserMenuAccess';
import * as A from 'common/data/Permissions/AdvertsAccess';
import * as C from 'common/data/Permissions/CandidatesAccess';
import * as AD from 'common/data/Permissions/ConfigurationAccess';
import { TopBarRoute } from 'common/models/TopBarTypes';
import NavBarSubmenuContainer from '../NavBar/NavBarSubmenuContainer';
interface Props {
  index: number;
  hoveredIndex: number | null;
  onMouseEnter: (i: number | null) => void;
  closeUserMenuHandler: () => void;
}

const routes: TopBarRoute[] = [
  {
    path: '/account/templates/activities',
    text: 'Activities',
    options: [
      {
        path: '/account/templates/activities/all',
        text: 'All',
        allow: P.AllowTemplates,
      },
      {
        path: '/account/templates/activities',
        text: 'Mine',
      },
    ],
  },
  {
    path: '/adverts/templates',
    text: 'Adverts',
    allow: A.AllowAdvertsAddEdit,
    options: [
      {
        path: '/adverts/templates/all',
        text: 'All',
        allow: P.AllowTemplates,
      },
      {
        path: '/adverts/templates',
        text: 'Mine',
      },
    ],
  },
  {
    path: '/configuration/adverts/screening-questionnaires',
    text: 'Advert Screening Questionnaires',
    allow: AD.AllowAdverts,
  },
  {
    path: '/account/templates/documents',
    text: 'Documents',
    allow: P.AllowTemplates,
    options: [
      {
        path: '/account/templates/documents/all',
        text: 'All',
        allow: P.AllowTemplates,
      },
      {
        path: '/account/templates/documents',
        text: 'Mine',
      },
    ],
  },
  {
    path: '/account/templates/interview-notes',
    text: 'Interview Notes',
    options: [
      {
        path: '/account/templates/interview-notes/all',
        text: 'All',
        allow: P.AllowTemplates,
      },
      {
        path: '/account/templates/interview-notes',
        text: 'Mine',
      },
    ],
  },
  {
    path: '/account/templates/messages',
    text: 'Messages',
    options: [
      {
        path: '/account/templates/messages/all',
        text: 'All',
        allow: P.AllowTemplates,
      },
      {
        path: '/account/templates/messages',
        text: 'Mine',
      },
    ],
  },
  {
    path: '/account/templates/reference-checks',
    text: 'Reference Checks',
    allow: C.AllowCandidatesModule,
    options: [
      {
        path: '/account/templates/reference-checks/all',
        text: 'All',
        allow: P.AllowTemplates,
      },
      {
        path: '/account/templates/reference-checks',
        text: 'Mine',
      },
    ],
  },
  {
    path: '/account/templates/screening-questions',
    text: 'Screening Questions',
    allow: C.AllowCandidatesModule,
    options: [
      {
        path: '/account/templates/screening-questions/all',
        text: 'All',
        allow: P.AllowTemplates,
      },
      {
        path: '/account/templates/screening-questions',
        text: 'Mine',
      },
    ],
  },
];

export default function WizTopBarTemplatesSubmenu({ index, hoveredIndex, onMouseEnter }: Props) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (index !== hoveredIndex) setAnchor(null);
  }, [index, hoveredIndex]);

  const handleHover = (e: React.MouseEvent<HTMLElement>) => {
    setAnchor(e.currentTarget);
    onMouseEnter(index);
  };

  const isHovered = index === hoveredIndex;
  const closeHandler = useCallback(() => setAnchor(null), []);

  return (
    <>
      <MenuItem onMouseEnter={handleHover}>
        <ListItemText>Templates</ListItemText>
        <ArrowRightIcon />
      </MenuItem>
      {anchor && (
        <NavBarSubmenuContainer
          anchor={anchor}
          options={routes}
          isRootHovered={isHovered}
          closeSubmodule={closeHandler}
        />
      )}
    </>
  );
}
